import React, { forwardRef, useMemo } from "react";

import {
  getProductImage,
  normalizeProductImage,
} from "../../utils/productImages";
import ResponsiveImage, {
  CATALOGUE_PRODUCT_IMAGE_SIZES,
  PRODUCT_DETAIL_IMAGE_SIZES,
} from "./ResponsiveImage";

export {
  CATALOGUE_PRODUCT_IMAGE_SIZES,
  PRODUCT_DETAIL_IMAGE_SIZES,
};

const ProductImage = forwardRef(function ProductImage(
  {
    product,
    image,
    fallback = "",
    alt = "",
    sizes,
    className,
    pictureClassName,
    loading = "lazy",
    decoding = "async",
    ...imgProps
  },
  ref,
) {
  const normalized = useMemo(
    () =>
      product
        ? getProductImage(product, fallback)
        : normalizeProductImage(image, fallback),
    [fallback, image, product],
  );

  return (
    <ResponsiveImage
      {...imgProps}
      ref={ref}
      image={normalized}
      fallback={fallback}
      alt={alt || normalized?.alt || "Product image"}
      sizes={sizes}
      className={className}
      pictureClassName={pictureClassName}
      loading={loading}
      decoding={decoding}
    />
  );
});

export default ProductImage;
